export enum MessageToolView {
    INBOX = 'inbox',
    NEW_MESSAGE = 'new_message',
    CONVERSATION = 'conversation',
}
